import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../store/AuthContext";
import useFetch from "../../components/hooks/useFetch";
import { abreAlertaDialog } from "../../components/modal/AlertaDialog";
import {
  ALTERAR_SENHA,
  ESQUECI_SENHA_PJ,
  ENVIAR_TOKEN_PJ,
} from "../../services/cadastro";
import { getIPAddress } from "../../components/utils/GetIPAddress";
import InputSenha from "../../components/form/InputSenha";
import InputToken from "../../components/form/InputToken";
import Input from "../../components/form/Input";
import InputCadastro from "../../components/form/InputCadastro";
import InputNomeCompleto from "../../components/form/InputNomeCompleto";
import "./RedefinirSenhaObrigatoria.css";
import { createFormSchemas } from "./Cadastro/FormSchema";

const RedefinirSenhaObrigatoria = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = React.useContext(AuthContext);
  const { request } = useFetch();
  const [ipAddress, setIpAddress] = useState("");
  const [meioEnvio, setMeioEnvio] = useState("E");
  const [tenhoCnpj, setTenhoCnpj] = useState("1");
  const [modalAbertoToken, setModalAbertoToken] = useState(false);
  const [senhaEnvio, setSenhaEnvio] = useState();
  const [idCorreiosEnvio, setIdCorreiosEnvio] = useState();

  const { formEsqueciSenhaPJ } = createFormSchemas(t);

  const methods = useForm({
    resolver: yupResolver(formEsqueciSenhaPJ),
    mode: "onSubmit",
    context: { tenhoCnpj },
  });

  useEffect(() => {
    getIPAddress().then(setIpAddress);
  }, []);

  useEffect(() => {
    if (user?.sub) {
      methods.setValue("idCorreios", user.sub);
      setIdCorreiosEnvio(user.sub);
    }
  }, [user, methods]);

  const formMethods = {
    inputRef: methods.register,
    errors: methods.formState.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const handleSubmit = async (data) => {
    var meioEnvioEnviar = methods.getValues("meioEnvio");
    if (!meioEnvioEnviar) {
      meioEnvioEnviar = "E";
    }
    setMeioEnvio(meioEnvioEnviar);
    setSenhaEnvio(methods.getValues("novaSenha"));
    const dados = {
      idCorreios: data.idCorreios,
      nome: data.nome,
      meioEnvio: meioEnvioEnviar,
      ...(data.an8 && { an8: data.an8 }),
      ...(data.numeroContrato && { numeroContrato: data.numeroContrato }),
    };

    const { response } = await request(ESQUECI_SENHA_PJ(dados, ipAddress));

    if (response.ok) {
      if (meioEnvioEnviar == "E") {
        abreAlertaDialog(t("cadastro.messages.success.token_sent_email"));
      } else {
        abreAlertaDialog(t("cadastro.messages.success.token_sent_mobile"));
      }
      openModalToken();
    }
  };

  const openModalToken = () => {
    setModalAbertoToken(true);
  };

  const reenviaToken = async () => {
    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: "ESQUECEU_SENHA",
    };
    const { response } = await request(
      ENVIAR_TOKEN_PJ(idCorreiosEnvio, token, ipAddress)
    );
    if (response.ok) {
      if (meioEnvio === "E") {
        abreAlertaDialog(t("cadastro.messages.success.token_sent_email"));
      } else {
        abreAlertaDialog(t("cadastro.messages.success.token_sent_mobile"));
      }
    }
  };

  const alterar = async () => {
    const token1 =
      document.getElementById("confirmarSenha1").value +
      document.getElementById("confirmarSenha2").value +
      document.getElementById("confirmarSenha3").value +
      document.getElementById("confirmarSenha4").value +
      document.getElementById("confirmarSenha5").value +
      document.getElementById("confirmarSenha6").value;
    if (token1.length < 6) {
      abreAlertaDialog(t("cadastro.messages.validation.token_required"));
    } else {
      const senhaEnviar = {
        senha: senhaEnvio,
        token: token1,
        idCorreios: idCorreiosEnvio,
      };
      const { response } = await request(ALTERAR_SENHA(senhaEnviar, ipAddress));

      if (response.ok) {
        abreAlertaDialog("Senha alterada com sucesso!");
        navigate("/principal");
      }
    }
  };

  const handleCancelar = () => {
    navigate("/redefinir-senha-obrigatoria", { replace: true });
  };

  const handleTenhoCnpj = (event) => {
    const value = event.target.value;
    setTenhoCnpj(value);
    methods.setValue("tenhoCnpj", value);
  };

  const handleMeioEnvioChange = (value) => {
    setMeioEnvio(value);
  };

  return (
    <>
      {!modalAbertoToken ? (
        <div className="redefinir-senha-obrigatoria">
          <div className="container">
            <div className="avatar-container">
              <img
                src="/images/carol-perfil.png"
                alt="Avatar"
                className="avatar"
              />
            </div>

            <h1 className="titulo">
              {t("cadastro.messages.info.dear_client")}
            </h1>

            <div className="texto-explicativo">
              <p>
                Como medida preventiva para proteger seus dados de cadastro e o
                acesso aos nossos sistemas, solicitamos que você altere sua
                senha. Essa ação ajuda a manter sua conta segura e evitar
                acessos indevidos.
              </p>
            </div>

            <form
              onSubmit={methods.handleSubmit(handleSubmit)}
              className="form-redefinir-senha"
            >
              <input type="hidden" {...methods.register("idCorreios")} />
              <input
                type="hidden"
                {...methods.register("tenhoCnpj")}
                value={tenhoCnpj}
              />

              <div className="campo-cnpj">
                <div className="radio-group">
                  <label className="radio">
                    <Input
                      type="radio"
                      id="tenhoCnpj"
                      name="tenhoCnpj"
                      value="1"
                      checked={tenhoCnpj === "1"}
                      onChange={handleTenhoCnpj}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">
                      {t("cadastro.forms.options.have_cnpj")}
                    </div>
                  </label>
                  <label className="radio">
                    <Input
                      type="radio"
                      id="naoTemCnpj"
                      name="naoTemCnpj"
                      value="0"
                      checked={tenhoCnpj === "0"}
                      onChange={handleTenhoCnpj}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">
                      {t("cadastro.forms.options.no_cnpj")}
                    </div>
                  </label>
                </div>
              </div>

              {tenhoCnpj === "0" && (
                <>
                  <InputCadastro
                    type="text"
                    id="an8"
                    name="an8"
                    label={t("cadastro.forms.labels.an8")}
                    maxLength="8"
                    {...formMethods}
                  />
                  <InputCadastro
                    type="text"
                    id="numeroContrato"
                    name="numeroContrato"
                    label={t("cadastro.forms.labels.contrato")}
                    maxLength="10"
                    {...formMethods}
                  />
                </>
              )}

              <InputNomeCompleto
                type="text"
                id="nome"
                name="nome"
                placeholder=""
                label={t("cadastro.forms.labels.company_name")}
                {...formMethods}
              />

              <div className="campo-senha">
                <InputSenha
                  type="password"
                  id="novaSenha"
                  name="novaSenha"
                  label={t("cadastro.forms.labels.new_password_detailed")}
                  placeholder=""
                  maxLength="15"
                  {...formMethods}
                />
                <div className="dica-senha">
                  Entre 8 a 15 caracteres com letras e números
                </div>
              </div>

              <div className="campo-confirmar-senha">
                <InputSenha
                  type="password"
                  id="confirmaSenha"
                  name="confirmaSenha"
                  label="Confirmar Senha*"
                  placeholder=""
                  maxLength="15"
                  {...formMethods}
                />
              </div>

              <div className="campo-token">
                <p className="pergunta-token">
                  {t("cadastro.messages.info.token_registration_method")}
                </p>
                <div className="radio-group">
                  <label className="radio">
                    <Input
                      type="radio"
                      id="E"
                      name="meioEnvio"
                      value="E"
                      checked={meioEnvio === "E"}
                      onChange={(e) => handleMeioEnvioChange(e.target.value)}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">
                      {t("principal.forms.labels.email_option")}
                    </div>
                  </label>
                  <label className="radio">
                    <Input
                      type="radio"
                      id="C"
                      name="meioEnvio"
                      value="C"
                      checked={meioEnvio === "C"}
                      onChange={(e) => handleMeioEnvioChange(e.target.value)}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">
                      {t("principal.forms.labels.phone_option")}
                    </div>
                  </label>
                </div>
              </div>

              <div className="botoes">
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={handleCancelar}
                >
                  {t("principal.forms.buttons.cancel")}
                </button>

                <button id="btn-finalizar" type="submit" className="btn-pre">
                  {t("cadastro.forms.buttons.change_password")}
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <form>
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt={t("cadastro.accessibility.carol_image")}
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t("cadastro.titles.finalize_change")}</h2>

              <p className="txt-finalizacao">
                {t("cadastro.messages.info.finalize_change")}
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t("cadastro.forms.buttons.resend_code")}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t("cadastro.forms.buttons.complete")}
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={() => navigate("/principal")}
                >
                  {t("cadastro.forms.buttons.cancel")}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default RedefinirSenhaObrigatoria;
